import { fcp } from './Metrics';
import { getPerformance, getPerformanceObserver, getXMLHttpRequest } from './utils/browser-interfaces';
import { calculateTTI } from './utils/calculate-tti';
import { computeLastKnownNetwork2Busy } from './utils/compute-last-known-network-2-busy';
import { createScheduler } from './utils/create-scheduler';
import { observeIncomingRequests } from './utils/observe-incoming-requests';
import { observeLongTaskAndResources } from './utils/observe-long-task-and-resources';
import { initMetric } from './lib/initMetric.js';
const TIME_GAP = 5000;
let save_tti = 0;
export const getFCP = () => {
    return fcp ? fcp.value : 0;
};
const checkAndReportTTI = (options, lastKnownNetwork2Busy, longTasks) => {
    const searchStartTime = getFCP();
    const tti = calculateTTI({
        searchStart: searchStartTime,
        checkTimeInQuiteWindow: performance.now(),
        longTasks: longTasks,
        lastKnownNetwork2Busy: lastKnownNetwork2Busy,
    });
    if (tti > 0 && save_tti !== tti) {
        save_tti = tti;
        const metric = initMetric('TTI');
        metric.value = tti;
        options(metric);
    }
};
export const getTTI = (options) => {
    const XMLHttpRequest = getXMLHttpRequest();
    const performanceObserver = getPerformanceObserver();
    const performance = getPerformance();
    if (!XMLHttpRequest || !performanceObserver || !performance) {
        return;
    }
    const longTasks = [];
    const networkRequests = [];
    const ttiCalculatorScheduler = createScheduler();
    const { getIncomingRequestsTimes } = observeIncomingRequests();
    const getLastKnownNetworkBusy = () => {
        return computeLastKnownNetwork2Busy(getIncomingRequestsTimes(), networkRequests);
    };
    // 监听 long task 和 network resource
    observeLongTaskAndResources((timeInfo) => {
        // 在 long task 5 秒 后尝试获取 tti
        longTasks.push(timeInfo);
        ttiCalculatorScheduler.resetScheduler(timeInfo.endTime + TIME_GAP);
    }, (timeInfo) => {
        networkRequests.push(timeInfo);
        // 遇到资源请求，在最后一次请求数大于 2 的时刻五秒后尝试获取 tti
        ttiCalculatorScheduler.resetScheduler(getLastKnownNetworkBusy() + TIME_GAP);
    });
    const checkAndReport = () => {
        checkAndReportTTI(options, getLastKnownNetworkBusy(), longTasks);
    };
    const lastLongTask = longTasks.pop()?.endTime || 0;
    ttiCalculatorScheduler.startSchedule(checkAndReport, Math.max(getLastKnownNetworkBusy() + TIME_GAP, lastLongTask));
};
